import { createContext, useState } from "react";

export const AppVersionContext = createContext({});

export const Provider = (props) => {
    const { children } = props;

    let emptyAppVersion = {
        id: "",
        type: null,
        name: "",
        description: "",
    };

    const [appVersion, setAppVersion] = useState(emptyAppVersion);
    const [appVersions, setAppVersions] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    const [appVersionDialog, setAppVersionDialog] = useState(false);

    const resetAppVersion = () => {
        setAppVersion(emptyAppVersion);
    };

    // Make the context object:
    const appVersionContext = {
        appVersion,
        resetAppVersion,
        setAppVersion,
        appVersions,
        setAppVersions,
        submitted,
        setSubmitted,
        appVersionDialog,
        setAppVersionDialog,
    };

    // pass the value in provider and return
    return <AppVersionContext.Provider value={appVersionContext}>{children}</AppVersionContext.Provider>;
};

export const { Consumer } = AppVersionContext;
